import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { findControl } from './form-builder-utils';
import {
  convertDateTimeToUTC,
  getDateFromString,
  isBetweenDateRanges,
  isDateAfterAnotherDay,
} from 'common';

export function ssGreaterThanOrEqualDate(
  relativeToControl: string,
  control?: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    const date = tryGetDateControlValue(findControl(c, false, control));
    const relativeMin = tryGetDateControlValue(
      findControl(c, true, relativeToControl)
    );

    return relativeMin !== undefined &&
      date !== undefined &&
      isDateAfterAnotherDay(relativeMin, date)
      ? { relativeToMinDate: true }
      : null;
  };
}

export function ssGreaterThanOrEqualUtcDate(
  relativeToControl: string,
  control?: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    const date = tryGetUtcDateControlValue(findControl(c, false, control));
    const relativeMin = tryGetUtcDateControlValue(
      findControl(c, true, relativeToControl)
    );

    return relativeMin !== undefined && date !== undefined && date < relativeMin
      ? { relativeToMinDate: true }
      : null;
  };
}

function tryGetDateControlValue(
  abstractControl: AbstractControl
): Date | undefined {
  //safety check
  if (!abstractControl?.value) {
    return undefined;
  }

  return getDateFromString(abstractControl.value);
}

function tryGetUtcDateControlValue(
  abstractControl: AbstractControl
): Date | undefined {
  //safety check
  if (!abstractControl?.value) {
    return undefined;
  }

  return convertDateTimeToUTC(abstractControl.value);
}

export function ssConflictingDateRanges(
  eventFormGroup?: FormGroup
): ValidatorFn {
  const dateRanges = eventFormGroup?.controls['dateRanges'].value;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || dateRanges.length === 0) {
      return null;
    }

    if (value && dateRanges.length > 0) {
      for (let range of dateRanges) {
        if (isBetweenDateRanges(value, range.startDate, range.endDate)) {
          return { conflictingDateRanges: true };
        }
      }
    }

    return null;
  };
}
